function Footer() {
    return (
        <footer className="footer">
            <p className="footer__text"> 2020 Mesto Russia</p>
        </footer>
    )
}
export default Footer;
